/* ============================================================
   Outback Comms — Stay Connected · Shopify interactivity
   Floating status ticker + mobile menu toggle
   ============================================================ */
(function () {
  'use strict';

  // -------- Floating live-status ticker --------
  var ticker = document.querySelector('[data-oc-floating-ticker]');
  if (ticker) {
    var loc = ticker.getAttribute('data-oc-location') || 'KIMBERLEY WA';
    var speeds = [82, 85, 87, 89, 91, 88, 86, 90];
    var pings = [17, 18, 19, 18, 20, 18, 17];
    var downs = [138, 142, 145, 140, 148, 141, 143];
    var i = 0;
    function tick() {
      i = (i + 1) % speeds.length;
      ticker.innerHTML =
        '<div><span class="oc-red">\u25CF</span> LIVE @ ' + speeds[i] + ' KM/H</div>' +
        '<div>' + downs[i % downs.length] + ' Mbps \u00B7 ' +
        pings[i % pings.length] + ' ms \u00B7 ' + loc + '</div>';
    }
    setInterval(tick, 2200);
  }

  // -------- Mobile nav toggle --------
  var burger = document.querySelector('[data-oc-nav-burger]');
  var menu = document.querySelector('[data-oc-mobile-menu]');
  if (burger && menu) {
    var toggle = function (force) {
      var open = typeof force === 'boolean' ? force : !menu.classList.contains('oc-open');
      menu.classList.toggle('oc-open', open);
      burger.classList.toggle('oc-open', open);
      burger.setAttribute('aria-expanded', String(open));
      menu.setAttribute('aria-hidden', String(!open));
      document.body.style.overflow = open ? 'hidden' : '';
    };
    burger.addEventListener('click', function () { toggle(); });
    menu.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') toggle(false);
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 900) toggle(false);
    });
  }
})();
